import { httpClientPrivate } from '@/libs/httpClient'
import { ClaimListResponse } from '../types'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'

const fetchClaimList = async (params: {
  searchDetails: string
  page: number
  limit: number
  sortBy: string
  filter: string
}) => {
  const searchDetails = params.searchDetails ? `search=${params.searchDetails}&` : ''
  const sortBy = params.sortBy ? `&sortBy=${params.sortBy}` : ''
  const filter = params.filter ? `&${params.filter}` : ''

  const response = await httpClientPrivate.get<ClaimListResponse>(
    `${config.restUrl}/v1/backoffice/e-claim?${searchDetails}page=${params.page}&limit=${params.limit}${sortBy}${filter}`,
  )

  return response.data
}

const useClaimList = (params: {
  searchDetails: string
  page: number
  limit: number
  sortBy: string
  filter: string
  enabled: boolean
}) => {
  const queryKey = ['useClaimList', params]
  const queryFn = async () => fetchClaimList(params)
  const queryResult = useQuery({ queryKey, queryFn, enabled: params.enabled })

  return { ...queryResult }
}

export { fetchClaimList, useClaimList }
